// extracted by mini-css-extract-plugin
module.exports = {"container":"Breadcrumb_container__3gqmo","nav":"Breadcrumb_nav__32Hrw","navItem":"Breadcrumb_navItem__nnDSB","dark":"Breadcrumb_dark__2obM0"};